// src/routes/domains/australia/index.ts
import { australiaRoutes } from './australia.routes';
import type { AppRoute } from '../../core/types';

/**
 * Lazy export wrapper for Australia routes.
 * Enables code splitting: the Australia routes chunk will only load when needed.
 */
export const loadAustraliaRoutes = (): Promise<AppRoute[]> => {
  return Promise.resolve(australiaRoutes);
};